var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1227 6.4955C39.1227 6.4955 49.0877 30.7925 32.8438 38.1645C39.5327 40.2125 41.6477 39.9185 41.6477 39.9185C41.6477 39.9185 47.1558 31.9705 45.9438 21.0605C44.7318 10.1505 41.7187 6.2975 39.1227 6.4955Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2087 51.9542C22.7137 51.9572 23.2097 51.8162 23.6377 51.5472C22.4617 53.8072 22.3727 56.4782 23.3977 58.8102C25.4397 58.2392 26.8977 56.4392 27.0297 54.3232L28.5007 55.4602C28.6257 55.5852 29.4397 53.3002 29.5237 53.0912C29.7057 52.1712 29.6767 51.2222 29.4407 50.3152C29.0297 48.6552 27.9337 47.2482 26.4247 46.4432C23.0227 44.8162 20.9467 49.1792 22.2087 51.9542Z",
    fill: "#FA532E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1299 34.8984C20.9209 37.0164 21.2129 39.1034 21.0469 41.2644C26.8389 43.1424 32.7139 45.0214 38.6729 46.3264C39.5699 43.8744 40.7909 42.1634 41.6479 39.9184C41.6469 39.9184 37.9039 36.4024 21.1299 34.8984Z",
    fill: "#FA532E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2106 40.6698L20.8086 35.6508C21.2576 24.4328 27.4246 13.3388 36.5246 6.69183C38.1036 5.52883 40.3256 5.86683 41.4876 7.44483C41.4926 7.45083 41.4966 7.45783 41.5016 7.46383C41.5436 7.50583 41.5846 7.54683 41.5846 7.58883C47.7426 16.8868 47.5346 31.7788 41.2106 40.6698Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6172 40.2227L50.4672 42.7067C51.0142 42.9167 51.6142 42.9467 52.1782 42.7897C56.4252 41.0787 48.4212 31.8947 44.9982 32.1457",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9753 35.6192C17.9593 35.0862 15.1413 35.0042 12.1253 34.4822C11.5413 34.4332 10.9863 34.2032 10.5393 33.8242C7.44034 30.4332 18.5753 25.6212 21.6013 27.2912",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6924 35.6172C20.4834 37.7352 20.7754 39.8222 20.6094 41.9832C26.4014 43.8612 32.2764 45.7402 38.2354 47.0452C39.1324 44.5932 40.3534 42.8822 41.2104 40.6372",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2595 51.5246C23.7645 51.5276 24.2605 51.3866 24.6885 51.1176C23.5125 53.3776 23.4235 56.0486 24.4485 58.3806C26.4905 57.8096 27.9485 56.0096 28.0805 53.8936L29.5515 55.0306C29.6765 55.1556 30.4905 52.8706 30.5745 52.6616C30.7565 51.7416 30.7275 50.7926 30.4915 49.8856C30.0805 48.2256 28.9845 46.8186 27.4755 46.0136C24.0735 44.3866 21.9975 48.7496 23.2595 51.5246Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8109 18.3174C32.8519 19.0054 31.5749 20.8974 31.6689 22.9714C31.8209 25.5084 33.9999 27.4414 36.5369 27.2904C38.1899 27.1914 39.6629 26.2114 40.3929 24.7254C41.5679 22.5104 40.7239 19.7624 38.5089 18.5874C38.4969 18.5814 38.4849 18.5744 38.4719 18.5684C37.3359 17.9954 36.0159 17.9054 34.8109 18.3174Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket3);
export default __webpack_public_path__ + "static/media/rocket-3.dd8a7c72ebf992e49f1f263f719ab974.svg";
export { ForwardRef as ReactComponent };